export * from './lib/shared-core-local-database.module';
